import { z } from 'zod';

const MAX_FILE_SIZE = 5000000; // 5MB
const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/svg+xml"];

export const updateSchoolSchema = z.object({
    schoolName: z.string().min(1, { message: "School name is required" }),
    schoolEmail: z.string().email({ message: "Invalid email address" }),
    schoolContact: z.string().min(1, { message: "School contact is required" }),
    address: z.string().min(1, { message: "Address is required" }).or(z.literal("")),
    country: z.string().min(1, { message: "Country is required" }).or(z.literal("")),

    principalName: z.string().min(1, { message: "Principal name is required" }),
    principalEmail: z.string().email({ message: "Invalid email address" }),
    principalContact: z.string().min(1, { message: "Principal contact is required" }),

    website_url: z.url("Invalid Website link").optional().or(z.literal("")),
    linkedin_link: z.url("Invalid LinkedIn link").optional().or(z.literal("")),
    instagram_link: z.url("Invalid Instagram link").optional().or(z.literal("")),
    youtube_link: z.url("Invalid YouTube link").optional().or(z.literal("")),
    facebook_link: z.url("Invalid Facebook link").optional().or(z.literal("")),
    logo: z
        .custom<File>((val) => val instanceof File, "Please upload a logo")
        .refine((file) => file.size <= MAX_FILE_SIZE, `Max file size is 5MB.`)
        .refine(
            (file) => ACCEPTED_IMAGE_TYPES.includes(file.type),
            "Only .jpg, .jpeg, .png, .webp and .svg formats are supported."
        )
        .optional()
        .nullable(),
});

export const superAdminUpdateSchoolSchema = updateSchoolSchema.extend({
    device_limit: z.coerce.number().min(0, { message: "Device limit is required and must be 0 or higher" }),
    device_expiry: z.string().min(1, { message: "License expiry date is required" }),
});

export type UpdateSchoolFormValues = z.infer<typeof updateSchoolSchema>;
export type SuperAdminUpdateSchoolFormValues = z.infer<typeof superAdminUpdateSchoolSchema>;
